
import PicZoom from 'vue-piczoom';
import detail from './detail_groupbuy.js';
import GoodsRecommend from '@/components/GoodsRecommend';
export default {
	name: 'groupbuy_detail',
	components: {
		PicZoom,
		GoodsRecommend
	},
	mixins: [detail]
};
